import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core';

import { ButtonComponent } from '../../../../common/button/components/button/button.component';
import { DividerComponent } from '../../../../common/divider/divider.component';
import { HeadingComponent } from '../../../../common/heading/heading.component';
import { IconHelpComponent } from '../../../../common/icon/icon-help/icon-help.component';
import type { IconSize } from '../../../../common/icon/icon.component';
import { IconComponent } from '../../../../common/icon/icon.component';
import type { IconName } from '../../../../common/icon/icons.type';
import { TabsComponent } from '../../../../common/tabs/tabs.component';
import { RtTooltip } from '../../../../common/tooltip/tooltip.directive';
import type { Variants } from '../../../../utils/variant/variant';
import { ComponentVariant } from '../../../../utils/variant/variant';

@Component({
  selector: 'rt-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-actions]': 'newButton || actionsSlot',
    '[class.has-tabs]': 'tabs',
    '[class.has-padding]': 'hasPadding',
    '[class.blue-bg]': 'hasBlueBg',
    '[class]': 'variant',
  },
  imports: [
    DividerComponent,
    HeadingComponent,
    IconComponent,
    IconHelpComponent,
    NgTemplateOutlet,
    RtTooltip,
  ],
})
export class DialogHeaderComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'dark', 'no-padding', 'no-bottom-padding'],
  ];
  @ComponentVariant(DialogHeaderComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public hasDivider: boolean = true;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public icon: IconName;
  @Input() public hint: string;
  @Input() public hasPadding: boolean = false;
  @Input() public hasBlueBg: boolean = false;
  @Input() public iconSize: IconSize = 'large-x';
  @Input() public iconMarginLeft: boolean = true;
  @Input() public actionsSlot: TemplateRef<any>;
  @Input() public badgesTpl: TemplateRef<any> | null = null;
  @Input() public subheadingTpl: TemplateRef<any> | null = null;
  @Input() public headingTpl: TemplateRef<any> | null = null;
  @Input() public stepText: string = '';

  @ContentChild(ButtonComponent)
  public newButton: ButtonComponent;

  @ContentChild(TabsComponent)
  public tabs: TabsComponent;
}
